import { X } from "lucide-react";
import React, { useEffect, useState } from "react";

interface ErrorToastProps {
	error: React.ReactNode;
	timeout?: number;
}

function ErrorToast({ error, timeout = 500000 }: ErrorToastProps) {
	const [show, setShow] = useState(true);

	// A new error re-opens the toast, otherwise dismissing one hides every later error too.
	useEffect(() => {
		setShow(true);
	}, [error]);

	useEffect(() => {
		const timer = setTimeout(() => setShow(false), timeout);
		return () => clearTimeout(timer);
	}, [timeout, error]);

	if (!show) return null;

	return (
		<div className="alert alert-danger flex items-center justify-between gap-3" role="alert">
			<div className="toast-body">{error}</div>
			<button
				type="button"
				className="shrink-0 text-red-600 opacity-70 hover:opacity-100"
				aria-label="Close"
				onClick={() => setShow(false)}
			>
				<X size={16} />
			</button>
		</div>
	);
}

export default ErrorToast;
